import { Mail, MapPin } from "lucide-react";
import { COMPANY, MAILTO_HREF } from "@/lib/constants";

export default function ContactSection({ compact = false }) {
  return (
    <div className={`grid gap-10 ${compact ? "md:grid-cols-2" : "md:grid-cols-2"}`}>
      <div className="flex flex-col justify-center">
        <h3 className="font-display text-2xl font-semibold text-charcoal">
          Let's talk about your project
        </h3>
        <p className="mt-3 text-steel">
          Reach out and our team will follow up to discuss scope, timelines, and
          next steps for your commercial or industrial project.
        </p>

        <div className="mt-6 space-y-4 text-charcoal">
          <div className="flex items-start gap-3">
            <MapPin size={20} className="mt-0.5 shrink-0 text-brick" />
            <span>
              {COMPANY.addressLine1}
              <br />
              {COMPANY.addressLine2}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Mail size={20} className="shrink-0 text-brick" />
            <a href={MAILTO_HREF} className="hover:text-brick">
              {COMPANY.email}
            </a>
          </div>
        </div>

        <a
          href={MAILTO_HREF}
          className="mt-8 inline-block w-fit rounded bg-brick px-8 py-4 font-display text-base uppercase tracking-wide text-offwhite transition-colors hover:bg-brick-light"
        >
          Email Us
        </a>
      </div>

      <div className="overflow-hidden rounded-lg shadow-sm ring-1 ring-black/5">
        <iframe
          title="VCO Group location"
          src={COMPANY.mapEmbedSrc}
          className="h-full min-h-[320px] w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
